import { render } from "./ListaSinistrosPagamentoView.vue?vue&type=template&id=409633d4&scoped=true"
import script from "./ListaSinistrosPagamentoView.vue?vue&type=script&lang=js"
export * from "./ListaSinistrosPagamentoView.vue?vue&type=script&lang=js"

import "./ListaSinistrosPagamentoView.vue?vue&type=style&index=0&id=409633d4&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-409633d4"]])

export default __exports__